import {classNames, React, observer} from '@api'
import {StackView} from '@stores'
import * as css from './CardStack.css'

interface MyProps {
  orientation?: 'horizontal' | 'vertical',
  renderCard: (index: number) => React.ReactNode,
  levelOfDetail?: number,
  stackView: StackView,
  className?: string
  count: number
}

export const CardStack = observer<MyProps>(({className, orientation, renderCard, levelOfDetail, stackView, count}) => {
  return (
    <div className={classNames(css.root, className)}
         data-lod={levelOfDetail ?? 0}
         data-stack-view={stackView}
         data-orientation={orientation}
         style={{'--item-count': count} as any}
    >
      {_.range(0, count).map(i => <div key={i} className={css.cardWrapper}
                                           style={{
                                             '--stack-index': i,
                                             } as any}>
        {renderCard(i)}
      </div>)}
    </div>
  )
})

CardStack.defaultProps = {
  orientation: 'horizontal'
}


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/CardStack.tsx